export const resolveUserProfileDocument = async ({
  snapshot,
  getServerSnapshot,
  user,
  userDocRef,
  setDoc,
  serverTimestamp,
  isStale = () => false
}) => {
  if (snapshot.exists()) {
    return { status: 'existing', data: snapshot.data() };
  }

  // A realtime cache miss is not proof that the server document is absent.
  const serverSnapshot = await getServerSnapshot(userDocRef);
  if (serverSnapshot.exists()) {
    return { status: 'existing', data: serverSnapshot.data() };
  }

  if (isStale()) {
    return { status: 'stale' };
  }

  const identityData = {
    email: user.email || '',
    displayName: user.displayName || '',
    photoURL: user.photoURL || '',
    provider: user.providerData?.[0]?.providerId || 'unknown',
    uid: user.uid,
    lastLogin: serverTimestamp()
  };

  await setDoc(userDocRef, identityData, { merge: true });
  return { status: 'created', data: identityData };
};
